import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import iconEye from '../../../images/icon-eye.svg';
import iconLoginAsUser from '../../../images/icon-line-manage-clients.svg';
import iconAssignProgram from '../../../images/assign-program.png';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { assignCoach, deleteClient } from '../../../redux/slices/admin/clientsSlice'; 
import { loginAsUser } from '../../../redux/slices/adminAuthSlice';
import { useNavigate } from 'react-router-dom';

const UnassignedTable = ({ handlePageChange, onUserSelect, openEditModal, openProgramListModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { unassigned_users, currentPage, totalPages, loading } = useSelector((state) => state.admin_unassigned_clients);
  const { userType } = useSelector((state) => state.protect);
 
  useEffect(() => {
    if (userType === 'client') {
      navigate('/~alexgambleadmin/meal-plan');
    }
  }, [userType]);
 
  return (
    <> 
    <div className="table-responsive">
      <table className="table table-striped table-users table-alex printarea">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Action</th>
            <th>Action By</th>
            <th>Action At</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {unassigned_users && unassigned_users.length > 0 ? (
            unassigned_users.map((user) => (
              <tr key={user.id}>

                <td>
                  <div className="text-start">
                    {user.first_name} {user.last_name}
                    <div><b>Email</b>: {user.email}</div>
                  </div>
                </td> 

                <td>{user.user_type == 1? '1:1' : 'Academy'}</td>

                <td>{ (user.new_assigned_coach_id == '' || user.new_assigned_coach_id == null) ? 'Unassigned':'Assigned'}</td>

                <td>
                  <div className="text-start">
                    {user.updated_by_name}
                     {user.updated_from_ip && (
                    <div>IP: {user.updated_from_ip}</div>
                    )}
                  </div>
                </td> 

                <td>{user.unassigned_at}</td>

                <td>
                  <div className="text-start">
                    {user.old_coach_name && (
                      <div>Old Coach: {user.old_coach_name}</div>
                    )}
                    {user.new_coach_name && (
                      <div>New Coach: {user.new_coach_name}</div>
                    )}
                  </div>
                </td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">{loading?'Loading Users List...':'No Users found'}</td>
            </tr>
          )}
        </tbody>
      </table>    
      </div> 
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
    </>
  );
};

export default UnassignedTable;